import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import MUIDataTable from "mui-datatables";
import { Badge } from 'reactstrap';
import { createMuiTheme } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { FormGroup, FormLabel, TextField } from '@material-ui/core';
import IntlMessages from "../../../../util/IntlMessages";
import { tsToDate, getAgeFromDob } from "../../../../util/dateUtil"
import { toTitleCase } from "../../../../util/generalUtil"
import LoadingAlert from "../../../../components/LoadingAlert"
import maleAvatar from '../../../../assets/images/icons/male-avatar.svg'
import femaleAvatar from '../../../../assets/images/icons/female-avatar.svg'
import {
    selectPlayer
} from '../../../../actions/PlayerAction';
class AllPlayerTable extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rowsExpanded: [],
            denseTable: false,
            vertical: true,
            playersData: []
        };
    }

    componentDidMount() {
        this.updatePlayerData()
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.assignCoachToPlayerLoader === true && this.props.assignCoachToPlayerLoader === false) || (prevProps.changeCoachToPlayerLoader === true && this.props.changeCoachToPlayerLoader === false) || (prevProps.removeCoachToPlayerLoader === true && this.props.removeCoachToPlayerLoader === false) || (prevProps.playersStoreData !== this.props.playersStoreData)) {
            this.showAlert(prevProps)
            this.updatePlayerData()
        }
    }

    updatePlayerData() {
        var playersData = [];
        this.props.playersStoreData.forEach(playerObj => {
            const eacl = playerObj.hasOwnProperty("eacl") ? playerObj.eacl : null
            var coachName = "";
            if (eacl !== null) {
                coachName = this.getCoachName(eacl)
            }
            const age = playerObj.hasOwnProperty("playerInfo") ? (playerObj.playerInfo.hasOwnProperty("dateOfBirthTs") ? getAgeFromDob(playerObj.playerInfo.dateOfBirthTs) : "") : ""
            const status = playerObj.hasOwnProperty("status") ? playerObj.status : "active"
            const avatar = playerObj.hasOwnProperty("playerInfo") ? (playerObj.playerInfo.hasOwnProperty("gender") ? (playerObj.playerInfo.gender === "female" ? femaleAvatar : maleAvatar) : maleAvatar) : maleAvatar
            const player = [avatar, playerObj.hasOwnProperty("fullName") ? playerObj.fullName : "", playerObj.hasOwnProperty("email") ? playerObj.email : "", playerObj.hasOwnProperty("playerInfo") ? (playerObj.playerInfo.hasOwnProperty("phone") ? playerObj.playerInfo.phone : "") : "", playerObj.hasOwnProperty("playerInfo") ? (playerObj.playerInfo.hasOwnProperty("gender") ? playerObj.playerInfo.gender : "male") : "male", age, playerObj.hasOwnProperty("playerInfo") ? (playerObj.playerInfo.hasOwnProperty("city") ? playerObj.playerInfo.city : "") : "", playerObj.hasOwnProperty("playerInfo") ? (playerObj.playerInfo.hasOwnProperty("country") ? playerObj.playerInfo.country : "") : "", playerObj.hasOwnProperty("planType") ? playerObj.planType : "no plan", status === "active" ? (playerObj.hasOwnProperty("createdAtTs") ? tsToDate(playerObj.createdAtTs) : "") : "", coachName !== "" ? coachName : ""];
            playersData.push(player);
        });
        this.setState({ "playersData": playersData })
    }

    getCoachName(eacl) {
        var coachName = ""
        for (var index = 0; index < eacl.length; index++) {
            if ((eacl[index].status === "active" || eacl[index].status === "pending") && eacl[index].hasOwnProperty("coachName")) {
                if (index === 0 || coachName === "") {
                    coachName += toTitleCase(eacl[index].coachName)
                } else {
                    coachName += ", " + toTitleCase(eacl[index].coachName)
                }
                if (eacl[index].status === "active") {
                    coachName += "-#active"
                } else if (eacl[index].status === "pending") {
                    coachName += "-#pending"
                }
            }
        }
        return coachName
    }

    coachColumn(coachName, key) {
        if (coachName !== "") {
            if (coachName.includes("-#active")) {
                return (
                    <div key={key}>{coachName.replace("-#active", "")} <Badge className="jr-rounded-xs text-uppercase" color="info">active</Badge></div>
                )
            } else if (coachName.includes("-#pending")) {
                return (
                    <div key={key}>{coachName.replace("-#pending", "")} <Badge className="jr-rounded-xs text-uppercase" color="warning">pending</Badge></div>
                )
            } else {
                return (
                    <div key={key}>{coachName}</div>
                )
            }
        } else {
            return (
                <span key={key} className='d-inline'> </span>
            );
        }
    }

    showAlert(prevProps) {
        if (prevProps.assignCoachToPlayerLoader === true && this.props.assignCoachToPlayerLoader === false) {
            this.props.assignCoachToPlayerError === null ? NotificationManager.success(<IntlMessages id="notification.assignCoach.successMessage" />) : NotificationManager.error(<IntlMessages id="notification.assignCoach.errorMessage" />);
        } else if (prevProps.changeCoachToPlayerLoader === true && this.props.changeCoachToPlayerLoader === false) {
            this.props.changeCoachToPlayerError === null ? NotificationManager.success(<IntlMessages id="notification.changeCoach.successMessage" />) : NotificationManager.error(<IntlMessages id="notification.changeCoach.errorMessage" />);
        } else if (prevProps.removeCoachToPlayerLoader === true && this.props.removeCoachToPlayerLoader === false) {
            this.props.removeCoachToPlayerError === null ? NotificationManager.success(<IntlMessages id="notification.removeCoach.successMessage" />) : NotificationManager.error(<IntlMessages id="notification.removeCoach.errorMessage" />);
        }
    }

    getMuiTheme = () =>
        createMuiTheme({
            overrides: {
                MUIDataTable: {
                    root: {
                        backgroundColor: '#AAF',
                    },
                    paper: {
                        boxShadow: 'none',
                    },
                },
                MuiToolbar: {
                    root: {
                        backgroundColor: '#f00',
                    },
                },
                MuiTableCell: {
                    head: {
                        backgroundColor: 'purple',
                    },
                },
                MUIDataTableSelectCell: {
                    headerCell: {
                        backgroundColor: 'blue',
                    },
                },
                MuiTableFooter: {
                    root: {
                        '& .MuiToolbar-root': {
                            backgroundColor: 'white',
                        },
                    },
                },
            },
        });

    toggleDenseTable = event => {
        this.setState({
            denseTable: event.target.checked,
        });
    };

    toggleResponsive = event => {
        this.setState({
            vertical: !!event.target.checked,
        });
    };

    render() {
        const columns = [
            {
                name: "",
                options: {
                    filter: false,
                    sort: false,
                    viewColumns: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <Avatar
                                alt={""}
                                src={value}
                                className="user-avatar-lg"
                            />
                        )
                    }
                }
            },
            {
                name: "Name",
                options: {
                    filter: false,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } })
                }
            },
            {
                name: "Email",
                options: {
                    filter: true,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } })
                }
            },
            {
                name: "Phone",
                options: {
                    filter: false,
                    display: false,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } })
                }
            },
            {
                name: "Gender",
                options: {
                    filter: true,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } })
                }
            },
            {
                name: "Age",
                options: {
                    filter: true,
                    display: true,
                    filterType: 'custom',
                    customFilterListOptions: {
                        render: v => {
                            if (v[0] && v[1] && this.state.ageFilterChecked) {
                                return [`Min Age: ${v[0]}`, `Max Age: ${v[1]}`];
                            } else if (v[0] && v[1] && !this.state.ageFilterChecked) {
                                return `Min Age: ${v[0]}, Max Age: ${v[1]}`;
                            } else if (v[0]) {
                                return `Min Age: ${v[0]}`;
                            } else if (v[1]) {
                                return `Max Age: ${v[1]}`;
                            }
                            return [];
                        },
                        update: (filterList, filterPos, index) => {
                            console.log('customFilterListOnDelete: ', filterList, filterPos, index);

                            if (filterPos === 0) {
                                filterList[index].splice(filterPos, 1, '');
                            } else if (filterPos === 1) {
                                filterList[index].splice(filterPos, 1);
                            } else if (filterPos === -1) {
                                filterList[index] = [];
                            }

                            return filterList;
                        },
                    },
                    filterOptions: {
                        names: [],
                        logic(age, filters) {
                            if (filters[0] && filters[1]) {
                                return age < filters[0] || age > filters[1];
                            } else if (filters[0]) {
                                return age < filters[0];
                            } else if (filters[1]) {
                                return age > filters[1];
                            }
                            return false;
                        },
                        display: (filterList, onChange, index, column) => (
                            <div>
                                <FormLabel>Age</FormLabel>
                                <FormGroup row>
                                    <TextField
                                        label='min'
                                        value={filterList[index][0] || ''}
                                        onChange={event => {
                                            filterList[index][0] = event.target.value;
                                            onChange(filterList[index], index, column);
                                        }}
                                        style={{ width: '45%', marginRight: '5%' }}
                                    />
                                    <TextField
                                        label='max'
                                        value={filterList[index][1] || ''}
                                        onChange={event => {
                                            filterList[index][1] = event.target.value;
                                            onChange(filterList[index], index, column);
                                        }}
                                        style={{ width: '45%' }}
                                    />
                                    {/* <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.ageFilterChecked}
                                                onChange={event => this.setState({ ageFilterChecked: event.target.checked })}
                                            />
                                        }
                                        label='Separate Values'
                                        style={{ marginLeft: '0px' }}
                                    /> */}
                                </FormGroup>
                            </div>
                        ),
                    },
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } })
                }
            },
            {
                name: "City",
                options: {
                    filter: false,
                    display: false,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } })
                }
            },
            {
                name: "Country",
                options: {
                    filter: false,
                    display: false,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } })
                }
            },
            {
                name: "Plan",
                options: {
                    filter: true,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } })
                }
            },
            {
                name: "Activation",
                options: {
                    filter: false,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } })
                }
            },
            // {
            //     name: "Status",
            //     options: {
            //         filter: true,
            //         setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } }),
            //         customBodyRender: (value, tableMeta, updateValue) => {
            //             return (
            //                 <Badge className="jr-rounded-xs text-uppercase" color={value === "active" ? "info" : (value === "pending" ? "warning" : "danger")}>{value}</Badge>
            //             );
            //         }
            //     }
            // },
            {
                name: "Coach",
                options: {
                    filter: true,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline', fontSize: '16px' } }),
                    customBodyRender: (value, tableMeta, updateValue) => {
                        var coachArray = value.split(", ")
                        return (
                            <div className='d-inline' style={{ width: 100 }}>
                                {coachArray.map((coach, index) => this.coachColumn(coach, index))}
                            </div>
                        )
                    }
                }
            }
        ];

        const options = {
            filterType: "dropdown",
            responsive: "scroll",
            selectableRows: "none",
            onRowClick: (rowData, rowMeta) => {
                // console.log("rowData : " + rowData)
                // console.log("rowMeta dataIndex : " + rowMeta.dataIndex)
                // console.log("rowMeta rowIndex : " + rowMeta.rowIndex)
                this.props.selectPlayer(this.props.playersStoreData[rowMeta.dataIndex]);
                this.props.history.push('/app/user/report')
            }

            // expandableRows: true,
            // expandableRowsHeader: false,
            // expandableRowsOnClick: true,
            // rowsExpanded: this.state.rowsExpanded,

            // onTableChange: (action, tableState) => {
            //     switch (action) {
            //         case "expandRow":
            //             var rowsExpanded = tableState.expandedRows.data.map(
            //                 item => item.dataIndex
            //             );
            //             if (rowsExpanded.length > 1) {
            //                 rowsExpanded = rowsExpanded.slice(-1);
            //             }
            //             this.setState(prevState => ({
            //                 rowsExpanded: rowsExpanded
            //             }));
            //             break;
            //         default:
            //             break;
            //     }
            // },


            // renderExpandableRow: (rowData, rowMeta) => {
            //     const colSpan = rowData.length + 1;
            //     return (
            //         <PlayerExpandView
            //             selectedPlayer={this.props.playersStoreData[rowMeta.dataIndex]}
            //             colSpan={colSpan}
            //         />
            //     );
            // },
            // onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) => console.log(curExpanded, allExpanded, rowsExpanded)
        };

        const message = this.props.assignCoachToPlayerLoader ? "Assigning coach" : this.props.changeCoachToPlayerLoader ? "Changing coach" : this.props.removeCoachToPlayerLoader ? "Removing coach" : ""
        return (
            <div>
                <LoadingAlert
                    message={message}
                />
                <MUIDataTable
                    title={"Players"}
                    data={this.state.playersData}
                    columns={columns}
                    options={options}
                />
            </div >
        );
    }
}

const mapStateToProps = ({ player }) => {
    const { assignCoachToPlayerLoader, changeCoachToPlayerLoader, removeCoachToPlayerLoader, assignCoachToPlayerError, changeCoachToPlayerError, removeCoachToPlayerError } = player;
    return { assignCoachToPlayerLoader, changeCoachToPlayerLoader, removeCoachToPlayerLoader, assignCoachToPlayerError, changeCoachToPlayerError, removeCoachToPlayerError }
}
export default withRouter(connect(mapStateToProps, {
    selectPlayer
})(AllPlayerTable));